/* Keep the cart drawer above floating third-party widgets (e.g. Microsoft Clarity
   Brand Agents chat). While the cart is open, app widgets fixed to the screen are
   hidden; they come straight back when the cart closes. Theme elements are untouched. */
(function () {
  if (window.__mpsCartOnTop) return;
  window.__mpsCartOnTop = true;

  var root = document.documentElement;
  var hidden = [];
  var observer = null;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, LINK: 1, NOSCRIPT: 1, TEMPLATE: 1, META: 1 };

  function isThemeElement(el) {
    return (
      el.matches('.shopify-section, .shopify-section-group, cart-drawer, side-drawer, .js-overlay, #MainContent, main, header, footer') ||
      !!el.querySelector('cart-drawer, .shopify-section')
    );
  }

  function isFixed(el) {
    var pos = getComputedStyle(el).position;
    return pos === 'fixed' || pos === 'sticky';
  }

  function hasFixedInside(el) {
    if (isFixed(el)) return true;
    var scope = el.shadowRoot || el;
    var kids = scope.querySelectorAll('*');
    for (var i = 0; i < kids.length && i < 60; i++) {
      if (isFixed(kids[i])) return true;
    }
    return false;
  }

  function tuck(el) {
    if (!el || el.nodeType !== 1 || SKIP_TAGS[el.tagName] || el.hasAttribute('data-mps-tucked')) return;
    if (isThemeElement(el) || !hasFixedInside(el)) return;
    el.setAttribute('data-mps-tucked', el.style.getPropertyValue('visibility') || '');
    el.style.setProperty('visibility', 'hidden', 'important');
    hidden.push(el);
  }

  function onOpen() {
    root.classList.add('mps-cart-open');
    Array.prototype.forEach.call(document.body.children, tuck);
    if (!observer && window.MutationObserver) {
      observer = new MutationObserver(function (list) {
        list.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, tuck); });
      });
    }
    if (observer) observer.observe(document.body, { childList: true });
  }

  function onClose() {
    root.classList.remove('mps-cart-open');
    if (observer) observer.disconnect();
    hidden.forEach(function (el) {
      var prev = el.getAttribute('data-mps-tucked');
      if (prev) el.style.setProperty('visibility', prev);
      else el.style.removeProperty('visibility');
      el.removeAttribute('data-mps-tucked');
    });
    hidden = [];
  }

  document.addEventListener('on:cart-drawer:before-open', onOpen);
  document.addEventListener('on:cart-drawer:before-close', onClose);
})();
